import { c as _c } from "react/compiler-runtime";
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeProvider } from "next-themes";
import { IntlProvider } from "react-intl";
import { useEffect, useState } from "react";
import { system } from "@/styles/theme";
export function UIProvider(props) {
  const $ = _c(4);
  const [hydrated, setHydrated] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timeout = setTimeout(() => setHydrated(true), 0);
      return () => clearTimeout(timeout);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!hydrated) {
    return null;
  }
  let t2;
  if ($[2] !== props.children) {
    t2 = <IntlProvider locale="en" defaultLocale="en"><ChakraProvider value={system}><ThemeProvider attribute="class">{props.children}</ThemeProvider></ChakraProvider></IntlProvider>;
    $[2] = props.children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}